/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useDispatch } from 'react-redux';
import { usePipelineContext } from '@/context/pipelineContext';

export const CompleteDealButton = ({ pipelineId, isDisabled }) => {
	const dispatch = useDispatch();
	const { dealRow } = useObjectContext();

	const {
		pipeline,
		stages,
		isLoading: isPipelineLoading,
		checkEndorsementStage,
		...pipelineQuery
	} = usePipelineContext(pipelineId);

	const isNewBusiness = pipelineId == process.env.REACT_APP_PIPELINE_NEW_BUSINESS;
	const isRenewal = pipelineId == process.env.REACT_APP_PIPELINE_RENEWALS;
	const isEndorsementPipeline = pipelineId == process.env.REACT_APP_PIPELINE_ENDORSEMENTS;
	const isDebtor = pipelineId == process.env.REACT_APP_PIPELINE_DEBTORS;
	

	const pipelineName =
		pipeline?.label === 'New Business'
			? 'New Business'
			: (pipeline?.label ?? '').slice(0, -1);

	const isEndorsementStage = checkEndorsementStage(dealRow?.dealStage);

	const buttonText = useMemo(() => {
		if (isEndorsementPipeline) return 'Complete Endorsement';
		if (isEndorsementStage) return 'Complete Endorsement';
		if(isDebtor) return 'Complete Debtor';
		return `Complete ${pipelineName}`;
	}, [isEndorsementPipeline, isEndorsementStage, pipelineName, isDebtor]);

	return (
		<Button
			sx={{ borderRadius: '10px' }}
			variant='contained'
			onClick={() => dispatch(openDialog('completeDeal'))}
			disabled={isDisabled || isPipelineLoading}
			startIcon={isPipelineLoading ? <CircularProgress size={20} color='inherit' /> : null}
		>
			{buttonText}
		</Button>
	);
};
